module.exports = __webpack_public_path__ + "static/media/Logo_Gold_v1_Black_Matte_No_Dither.7aadbaf7.gif";